import React, { useContext, useEffect, useState } from "react";
import ToastMessage from "../../../commonComponents/toastMessage/ToastMessage";
import { useBreakpoints } from "../../customHooks/useBreakpoints";
import './toast.scss';

const ToastContext = React.createContext();
const { Provider } = ToastContext;

export function generateUEID() {
  let first = (Math.random() * 46656) | 0;
  let second = (Math.random() * 46656) | 0;
  first = ("000" + first.toString(36)).slice(-3);
  second = ("000" + second.toString(36)).slice(-3);
  return first + second;
}

function ToastDataProvider(props) {
  const [toasts, setToasts] = useState([]);
  const { breakpoint } = useBreakpoints();

  const onDismiss = (id) => () => {
    // console.log(id);
    removeToast(id);
  };

  const addToast = (type, message) => {
    if (toasts.length < 5) {
      const id = generateUEID();
      setToasts((state) => {
        const newToast = { id, message, type };
        const toasts = breakpoint === 'xs' ? [newToast, ...state] : [...state, newToast];

        return toasts;
      });
    }
  };

  const removeToast = (id) => {
    setToasts((state) => {
      const toasts = state.filter((t) => t.id !== id);
      return toasts;
    });
  };

  return (
    <Provider value={{ addToast, removeToast }}>
      {props.children}
      <div className={`toast-wrapper`}>
          {toasts.map((ts) => (
              <Toast
                key={ts.id}
                onDismiss={onDismiss(ts.id)}
                message={ts.message}
                type={ts.type}
              />
          ))}
      </div>
    </Provider>
  );
  
}

function Timer(callback, delay) {
  let timerId;
  let start = delay;
  let remaining = delay;

  this.clear = function () {
    clearTimeout(timerId);
  };

  this.pause = function () {
    clearTimeout(timerId);
    remaining -= Date.now() - start;
  };

  this.resume = function () {
    start = Date.now();
    clearTimeout(timerId);
    timerId = setTimeout(callback, remaining);
  };

  this.resume();
}

const Toast = (props) => {
  const { message, type, onDismiss } = props;

  var timeout;

  useEffect(() => {
    startTimer();
    return () => {
      clearTimer();
    };
  }, []);

  const startTimer = () => {
    timeout = new Timer(onDismiss, 4000);
  };

  const clearTimer = () => {
    if (timeout) timeout.clear();
  };

  return (
    <ToastMessage type={type} onDismiss={onDismiss}>{message}</ToastMessage> 
  );
};


export const useToastDataContext = () => useContext(ToastContext);
export default ToastDataProvider;